export const APP_TITLE = '供銷運籌管理'
